/**
 * Build a Yandex Maps URL that shows a specific destination for a quest point.
 *
 * Why "whatshere" mode, not "routes"?
 *
 * Quest destinations are often abandoned buildings, forest points, parking
 * lots, or other locations that don't sit on a specific OSM building or POI.
 * In `rtext=~lat,lon&rtt=auto` route mode, Yandex labels the destination
 * panel with the nearest named container it can find — the city district,
 * a microrayon, a village — and the player sees a label that looks like
 * the WRONG location even though the pin is physically correct (e.g. pin
 * at 56.1324,47.2516 shows "микрорайон Благовещенский" in the Куда panel).
 *
 * "whatshere" mode opens a left-side card that puts the exact coordinates
 * in bold as the primary identifier AND includes a "Маршрут" button for
 * one-click routing. The pin still lands on the exact point, but the user
 * immediately sees the coordinates they verified match.
 *
 * URL gotcha: `whatshere[point]` wants square brackets URL-encoded as
 * %5B/%5D for some user agents. Coordinate order is lon,lat (opposite of
 * the `rtext=` param). `ll=` also takes lon,lat and centres the viewport.
 */
export function buildYandexMapsUrl(
  lat: number | null | undefined,
  lon: number | null | undefined,
  address: string | null | undefined,
): string | null {
  if (lat != null && lon != null && !Number.isNaN(lat) && !Number.isNaN(lon)) {
    return `https://yandex.ru/maps/?mode=whatshere&whatshere%5Bpoint%5D=${lon},${lat}&whatshere%5Bzoom%5D=17&ll=${lon},${lat}&z=17`;
  }
  if (address != null && address.length > 0) {
    return `https://yandex.ru/maps/?text=${encodeURIComponent(address)}`;
  }
  return null;
}
